'use strict';
import { device } from './utils';
import './lib/slick';
import inView from 'in-view';
import { Intro, SlideAnime, InViewAnime } from './helpers/animation';
import Sticky from './helpers/stickyBanner';

(function (window, $) {
  $(function () {
    // device check!
    let deviceType = device.ios ? 'ios' : device.android ? 'android' : 'pc';
    if (deviceType === 'ios') {
      let standalone = window.navigator.standalone,
        userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent);

      if (!standalone && safari) {
        //browser
      } else if (standalone && !safari) {
        //standalone
      } else if (!standalone && !safari) {
        //uiwebview
        deviceType = 'ios-webview';

        // TEST
        /*let dom = $('<div><h2>::: iOS WebView :::</h2></div>');
        dom.css({
            position: 'fixed',
            zIndex: 99999999,
            top: 100,
            left: 50,
            background: 'red',
            color: 'white'
        });
        $('body').append(dom);*/
      }
    }
    $('body').attr('data-device-type', deviceType);

    // animation: INTRO
    let intro = new Intro($('.intro'), {
      onComplete: () => {},
    });
    setTimeout(() => {
      intro.play();
    }, 360);

    let slideAnimations = [];
    $('.slide__wrap .slide__content').each((i, slide) => {
      slideAnimations.push(new SlideAnime($(slide), { index: i, deviceType }));
    });

    $('.intro .images').slick({
      // infinite: true,
      arrows: false,
      mobileFirst: true,
      speed: 500,
      slidesToShow: 1,
      swipe: false,
      draggable: false,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnFocus: false,
      pauseOnHover: false,
    });

    // animation: Slide
    $('.slide__wrap .title').each((i, title) => {
      let t = $('.slide__title .title').eq(i);
      if (t.length && t.find('.text').length) {
        t.find('.text').append($(title).html());
      }
    });

    const initialSlide = 0;
    const BREAK_POINT = 959;
    const $slider = $('.slide__wrap');
    const $titles = $('.slide__title .title');

    $slider.slick({
      infinite: true,
      arrows: false,
      responsive: [
        {
          breakpoint: BREAK_POINT,
          settings: {
            dots: false,
            fade: true,
          },
        },
      ],
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 4000,
      initialSlide,
      mobileFirst: true,
      dots: true,
      speed: 500,
      slidesToShow: 1,
      adaptiveHeight: true,
    });

    let timeoutId = -1;
    $titles.eq(initialSlide).addClass('on');
    $slider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
      // before
      if (currentSlide === nextSlide) return;

      $titles.eq(currentSlide).removeClass('on');
      $titles.eq(nextSlide).addClass('on');

      if (timeoutId !== -1) {
        clearTimeout(timeoutId);
      }
      // console.log(currentSlide, nextSlide);
      slideAnimations[currentSlide].reverse(0.8);
      timeoutId = setTimeout(() => {
        slideAnimations[nextSlide].play();
      }, 300);
    });
    $slider.on('afterChange', function (e, slick, currentSlide) {
      // after
      // slideAnimations[currentSlide].play();
    });

    $titles.click(function (e) {
      $slider.slick('slickGoTo', $(this).index());
    });

    // in view - element check
    // inView.offset(100);
    inView('[data-in-view]').on('enter', (el) => {
      if ($(el).hasClass('slide__wrap') && typeof $(el).data('is-play') === 'undefined') {
        $slider.slick('slickGoTo', initialSlide);
        // $slider.slick("setOption", "autoplay", true, true);
      }

      InViewAnime.play($(el));
    });

    slideAnimations[initialSlide].play();

    // sticky banner
    const $bannerEle = $('.sticky-banner');
    if ($bannerEle.length) {
      const $window = $(window);
      const $sticky = new Sticky($bannerEle);
      $bannerEle.click(() => {
        let top = $('.section.event').offset().top;
        TweenMax.to('html, body', 0.8, { scrollTop: top, ease: Power3.easeOut });
      });

      $window.resize(() => {
        $sticky.scroll();
      });
      $window.scroll(() => {
        $sticky.scroll();
      });
      $sticky.scroll();
    }

    // Share
    try {
      promotionShare('더욱 안전하고 간편하게! NC 인증기');
    } catch (err) {
      console.log(err);
    }
  });
})(window, $);
